var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_point_style_interface = function () {
    OCS.Viewer.Interfaces.OlPointStyle = {
        options: {
            layer_style_ops: {prefix: false, value_var: null, alpha: "1.0", precision: 0, suffix: null},
            point_style_type_text: 'point',
            point_style_ops: {
                fill_color: 'rgba(210, 160, 20, 0.5)',
                stroke_color: 'rgba(210, 160, 20, 0.9)',
                stroke_width: 2,
                text: {
                    font_size: '16px',
                    font_family: 'helvetica,arial,sans-serif',
                    fill_color: 'rgba(0, 0, 0, 1)',
                    fill_width: 2,
                    stroke_color: 'rgba(255, 255, 255, 1)',
                    stroke_width: 5
                },
                image: {
                    fill_color: 'rgba(210, 160, 20, 0.9)',
                    radius: 3,
                    stroke_color: 'rgba(210, 160, 20, 0.9)',
                    stroke_width: 2,
                    type: 'Circle'
                }
            }
        },
        get_point_layer_style_method: function (in_feature, res) {
            var text, feature, features;
            features = in_feature.get('features');
            if (features && features.length) {
                feature = in_feature.get('active_feature');
                if (!feature) {
                    feature = features[0];
                }
            } else {
                feature = in_feature;
            }
            if (this.options.layer_style_ops.value_var) {
                text = feature.get(this.options.layer_style_ops.value_var);
                text = (text) ? (this.options.layer_style_ops.prefix ? this.options.layer_style_ops.prefix : "") + parseFloat(text).toFixed(this.options.layer_style_ops.precision) + (this.options.layer_style_ops.suffix ? this.options.layer_style_ops.suffix : "") : "";
            }
            if (text === null || text === undefined) {
                text = "";
            }
            if (!this.style_cache[text]) {
                // Get the style object given the options we have
                var style = this.get_style_with_ops(this.build_style_ops(this.set_style_ops(this.options.point_style_ops, {'text': {'text': text}})));
                this.style_cache[text] = [style];
            }
            return this.style_cache[text];
        }
    }; // End OCS.Viewer.Interfaces.OlShapeStyle
};
OCS.Viewer.Functions.define_ol_point_style_interface();